import { motion } from "framer-motion";
import { Check, ArrowRight } from "lucide-react";

export const Commissions = ({ t }) => (
  <section id="commissions" data-testid="commissions-section" className="py-24 lg:py-32 bg-[#2D1810]">
    <div className="max-w-7xl mx-auto px-6 lg:px-12 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.7 }}
        className="lg:col-span-6"
      >
        <p className="text-xs font-semibold uppercase tracking-[0.25em] text-[#D9B36A] mb-4">
          {t.commissions.overline}
        </p>
        <h2 className="font-serif font-light text-4xl sm:text-5xl text-[#F5F2EC] tracking-tight leading-tight">
          {t.commissions.title}
        </h2>
        <p className="mt-6 text-base sm:text-lg text-[#F5F2EC]/75 leading-relaxed">{t.commissions.text}</p>
        <ul className="mt-8 space-y-4">
          {t.commissions.points.map((p, i) => (
            <li key={i} data-testid={`commission-point-${i}`} className="flex items-start gap-3 text-[#F5F2EC]/85">
              <Check size={18} className="mt-1 text-[#D9B36A] shrink-0" />
              <span className="text-sm sm:text-base">{p}</span>
            </li>
          ))}
        </ul>
        <a
          href="#quote"
          data-testid="commissions-cta"
          className="mt-10 inline-flex items-center gap-2 bg-[#D4AF37] text-[#2D1810] px-8 py-4 text-sm font-semibold rounded-sm hover:bg-[#c9a227] hover:-translate-y-1 transition-[transform,background-color] duration-300"
        >
          {t.commissions.cta}
          <ArrowRight size={16} />
        </a>
      </motion.div>

      <motion.div
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.7, delay: 0.15 }}
        className="lg:col-span-6"
      >
        <div className="grid grid-cols-2 gap-4 sm:gap-6 items-start">
          {["table-desk", "commission-door-2", "door-double-dining", "commission-detail-2"].map((key, i) => (
            <figure key={key} data-testid={`commissions-image-${i + 1}`}>
              <div className="overflow-hidden rounded-sm ring-1 ring-[#D4AF37]/25 aspect-[3/4]">
                <img
                  src={`/images/${key}.webp`}
                  alt={t.commissions.captions[i]}
                  loading="lazy"
                  className="w-full h-full object-cover"
                />
              </div>
              <figcaption className="mt-2.5 flex items-baseline gap-2">
                <span className="text-[10px] font-semibold tracking-[0.15em] text-[#D9B36A]">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <span className="text-[11px] sm:text-xs text-[#F5F2EC]/60 leading-snug">
                  {t.commissions.captions[i]}
                </span>
              </figcaption>
            </figure>
          ))}
        </div>
      </motion.div>
    </div>
  </section>
);
